var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.permissions.chemical)?_c('div',{staticClass:"chemical-entry"},[_c('main',{ref:"chemicalContainerRef"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }